import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Badge } from '@/components/ui/badge'
import {
  usePendingPackPurchasesQuery,
  useConfirmPackPurchaseMutation,
} from '@/hooks/usePlatformPacks'

function money(n: number) {
  return `${new Intl.NumberFormat('fr-FR').format(n)} CFA`
}

function dateText(value: string) {
  return new Date(value).toLocaleString('fr-FR')
}

export default function PlatformPacksPage() {
  const { data = [], isLoading } = usePendingPackPurchasesQuery()
  const confirmMut = useConfirmPackPurchaseMutation()

  return (
    <div className='space-y-6'>
      <div className='flex items-center justify-between'>
        <div>
          <h2 className='text-xl font-semibold'>Demandes de packs WhatsApp</h2>
          <p className='text-sm text-muted-foreground'>
            Confirmez après réception du paiement pour créditer le quota.
          </p>
        </div>
        {data.length > 0 && (
          <Badge variant='destructive'>{data.length} en attente</Badge>
        )}
      </div>

      {isLoading ? (
        <p className='text-sm text-muted-foreground'>Chargement...</p>
      ) : data.length === 0 ? (
        <Card>
          <CardContent className='py-10 text-center text-sm text-muted-foreground'>
            Aucune demande en attente.
          </CardContent>
        </Card>
      ) : (
        <div className='space-y-3'>
          {data.map((purchase) => (
            <Card key={purchase.id}>
              <CardHeader className='pb-2'>
                <div className='flex items-start justify-between gap-4'>
                  <div>
                    <CardTitle className='text-base'>
                      {purchase.owner.name}
                    </CardTitle>
                    <p className='text-sm text-muted-foreground mt-0.5'>
                      {purchase.pack.name} — {purchase.pack.messages} messages
                    </p>
                  </div>
                  <div className='text-right shrink-0'>
                    <div className='font-semibold tabular-nums'>
                      {money(purchase.amountCfa)}
                    </div>
                    <div className='text-xs text-muted-foreground mt-0.5'>
                      {dateText(purchase.createdAt)}
                    </div>
                  </div>
                </div>
              </CardHeader>
              <CardContent className='pt-0'>
                <div className='flex items-center justify-between'>
                  <Badge variant='secondary'>{purchase.pack.code}</Badge>
                  <Button
                    size='sm'
                    onClick={() => confirmMut.mutate(purchase.id)}
                    disabled={confirmMut.isPending}
                  >
                    Confirmer le paiement
                  </Button>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  )
}
